module.exports = __webpack_public_path__ + "img/coins.dafab533.png";